import { FEATURED_FILTER, SEARCH } from "./actionTypes";

export const featuredFilter = (status) => {
  return {
    type: FEATURED_FILTER,
    payload: status,
  };
};

export const search = (name) => {
  return {
    type: SEARCH,
    payload: name,
  };
};
